import React, { useEffect } from 'react';
import { MENU_SECTIONS, formatPrice } from './menuData';
import SeccionAlmuerzos from './SeccionAlmuerzos';
import './MenuPublico.css';

const imageUrl = (name) => `${process.env.PUBLIC_URL}/menu-fotos/${name}.webp`;

const Wave = () => (
    <svg className="mtn-wave" viewBox="0 0 1440 90" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0 90V38C240 92 520 104 790 70C1040 38 1270 4 1440 0V90Z" />
    </svg>
);

const Polaroid = ({ photo, index }) => (
    <figure className={`mtn-polaroid ${index % 2 ? 'mtn-polaroid--right' : 'mtn-polaroid--left'}`}>
        <img className="mtn-pin" src={imageUrl('pin')} alt="" width="32" height="32" loading="lazy" />
        <img src={imageUrl(photo.src)} alt={photo.alt} width={photo.width} height={photo.height} loading="lazy" />
    </figure>
);

const MenuItem = ({ item }) => (
    <li className="mtn-item">
        <div className="mtn-item-row">
            <span className="mtn-item-name">{item.name}</span>
            <span className="mtn-item-dots" aria-hidden="true"></span>
            <span className="mtn-item-price">{formatPrice(item.price)}</span>
        </div>
        {item.description && <p className="mtn-item-description">{item.description}</p>}
    </li>
);

const MenuSection = ({ section }) => (
    <section id={section.id} className="mtn-section">
        {section.band && (
            <div className="mtn-band">
                <div className="mtn-band-inner">
                    <h2 className="mtn-band-title">{section.title}</h2>
                    <img src={imageUrl(section.band.src)} alt={section.band.alt} width={section.band.width} height={section.band.height} loading="lazy" />
                </div>
                <Wave />
            </div>
        )}
        <div className="mtn-section-inner">
            <div className="mtn-section-list">
                {!section.band && (
                    <h2 className="mtn-section-title">
                        <i className={`bi ${section.icon}`} aria-hidden="true"></i>
                        {section.title}
                    </h2>
                )}
                <ul className="mtn-items">
                    {section.items.map((item) => <MenuItem key={item.name} item={item} />)}
                </ul>
            </div>
            <div className="mtn-section-photos">
                {section.photos.map((photo, index) => <Polaroid key={photo.src} photo={photo} index={index} />)}
            </div>
        </div>
    </section>
);

const Signature = () => (
    <p className="mtn-signature">
        <span>Un lugar con</span>
        <small>Sabor a tradición</small>
    </p>
);

const MenuPublico = () => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = 'Menú | La Casa del Tío Nel';
        return () => { document.title = previousTitle; };
    }, []);

    return (
        <div className="mtn-page">
            {/* El mismo CDN de íconos que usa la barra lateral del sistema */}
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css" />
            <header className="mtn-hero" style={{ backgroundImage: `url(${imageUrl('fondo-pizarra')})` }}>
                <div className="mtn-hero-inner">
                    <div className="mtn-hero-text">
                        <h1>
                            <span className="mtn-hero-menu">Menú</span>
                            <span className="mtn-hero-line" aria-hidden="true"></span>
                            <span className="mtn-hero-small">La casa del</span>
                            <span className="mtn-hero-name">Tío Nel</span>
                        </h1>
                    </div>
                    <img className="mtn-hero-tray" src={imageUrl('bandeja')} alt="Bandeja de desayuno con café, tostadas y tortilla" width="450" height="313" />
                </div>
                <Wave />
                <img className="mtn-logo" src={imageUrl('logo')} alt="Logo de La Casa del Tío Nel" width="240" height="240" />
            </header>

            <nav className="mtn-nav" aria-label="Secciones del menú">
                <div className="mtn-nav-inner">
                    {MENU_SECTIONS.map((section) => (
                        <a key={section.id} href={`#${section.id}`}>{section.title}</a>
                    ))}
                    <a href="#almuerzos">Almuerzos</a>
                </div>
            </nav>

            <main>
                {MENU_SECTIONS.map((section) => <MenuSection key={section.id} section={section} />)}
                <SeccionAlmuerzos photoUrl={imageUrl('salon')} />
            </main>

            <footer className="mtn-footer">
                <Signature />
            </footer>
        </div>
    );
};

export default MenuPublico;
